import { BRIEF_TEXT_BOLD } from "@nlc/shared-types";

import { cn } from "@/utils/cn";

type BriefTextProps = {
  /** Shown (muted) when the value is empty. */
  placeholder: string;
  value: string;
};

function withBold(text: string) {
  // Splitting on the capture group puts each bold text at an odd index.
  return text.split(BRIEF_TEXT_BOLD).map((part, index) =>
    index % 2 === 1 ? (
      <strong className="font-semibold text-text-primary" key={index}>
        {part}
      </strong>
    ) : (
      part
    ),
  );
}

/** Read-only view of a templated brief field, line breaks and **bold** kept. */
export function BriefText({ placeholder, value }: BriefTextProps) {
  return (
    <p
      className={cn(
        "whitespace-pre-wrap text-sm leading-relaxed text-text-secondary",
        !value && "italic text-text-tertiary",
      )}
    >
      {value ? withBold(value) : placeholder}
    </p>
  );
}
